var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPhotoshop(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1333.34 1300.01",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    imageRendering: "optimizeQuality",
    fillRule: "evenodd",
    clipRule: "evenodd",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0c0824",
    d: "M55.55 55.55h1222.23v1188.9H55.55z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.55 55.55h1222.23v1188.9H55.55V55.55zM0 1300.01h1333.34V0H0v1300.01zm898.89-766.68c-43.89 0-58.89 22.22-58.89 40.56 0 20 10 33.89 68.89 64.45 87.22 42.22 114.45 82.78 114.45 142.22 0 88.89-67.78 136.67-159.45 136.67-48.33 0-90-10-113.89-23.89-3.89-1.67-4.44-4.44-4.44-8.89v-81.67c0-5.56 2.78-7.22 6.67-4.44 35 22.78 75 32.78 111.67 32.78 43.89 0 62.22-18.33 62.22-43.33 0-20-12.78-37.78-68.89-66.67-78.89-37.78-111.67-76.11-111.67-140 0-71.67 56.11-131.11 153.34-131.11 47.78 0 81.11 7.22 99.44 15.56 4.44 2.78 5.56 7.22 5.56 11.11v76.11c0 4.44-2.78 7.22-8.33 5.55-24.44-15.55-60.55-25-96.66-25zm-477.78 66.11c12.78 1.11 22.78 1.11 45 1.11 65 0 126.11-22.78 126.11-111.11 0-70.56-43.89-106.11-117.78-106.11-22.22 0-43.33 1.11-53.33 1.67v214.45zm-98.89-295c0-3.89 7.78-6.67 12.22-6.67 35.56-1.67 88.33-2.78 143.33-2.78 153.89 0 213.89 84.45 213.89 192.22 0 141.11-102.22 201.67-227.78 201.67-21.11 0-28.33-1.11-43.33-1.11v213.34c0 4.44-1.67 6.67-6.67 6.67h-85c-4.44 0-6.67-1.67-6.67-6.67V304.44z",
    fill: "#31c5f0"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhotoshop);
export default __webpack_public_path__ + "static/media/photoshop.13f606be2a55861f49e54cb2d29ad326.svg";
export { ForwardRef as ReactComponent };